import type { InvoiceAmounts, InvoiceMatchResult } from './invoiceMatch.types'

/**
 * Retool warned when `|transaction − remaining| >= $0.01`. Amounts are integer cents, so any
 * non-zero difference is a mismatch.
 */
export const compareTransactionToInvoice = (
  transactionAmount: number,
  invoice: InvoiceAmounts,
): InvoiceMatchResult => {
  const remainingCents = invoice.amount - invoice.paidAmount
  const signedDifference = transactionAmount - remainingCents

  if (signedDifference === 0) {
    return { kind: 'match', remainingCents, differenceCents: 0 }
  }

  return {
    kind: signedDifference > 0 ? 'overfund' : 'underfund',
    remainingCents,
    differenceCents: Math.abs(signedDifference),
  }
}
